import { isSupabaseConfigured, supabase } from "./supabase";
import { getFunctionsErrorDetails } from "./functionErrors";

export const ordersService = {
  async verifyPaymentAndCreateOrder(orderPayload) {
    if (!isSupabaseConfigured) {
      throw new Error("Checkout is not configured yet. Add your Supabase settings to .env.");
    }

    const { data, error } = await supabase.functions.invoke("verify-paystack-payment", {
      body: orderPayload,
    });

    if (error) {
      const details = await getFunctionsErrorDetails(error, "Order verification failed.");
      throw new Error(details);
    }
    if (!data?.success) {
      throw new Error(data?.message || "Order verification failed.");
    }

    return data;
  },

  async fetchAdminOrders(accessCode) {
    if (!isSupabaseConfigured) {
      throw new Error("Admin orders are not configured yet. Add your Supabase settings to .env.");
    }

    const { data, error } = await supabase.functions.invoke("admin-orders", {
      body: { accessCode, action: "list" },
    });

    if (error) {
      const details = await getFunctionsErrorDetails(error, "Failed to load orders.");
      throw new Error(details);
    }
    if (!data?.success) {
      throw new Error(data?.message || "Failed to load orders.");
    }

    return data.orders || [];
  },

  async updateAdminOrderStatus(accessCode, orderId, status) {
    if (!isSupabaseConfigured) {
      throw new Error("Admin orders are not configured yet. Add your Supabase settings to .env.");
    }

    const { data, error } = await supabase.functions.invoke("admin-orders", {
      body: { accessCode, action: "update-status", orderId, status },
    });

    if (error) {
      const details = await getFunctionsErrorDetails(error, "Failed to update order status.");
      throw new Error(details);
    }
    if (!data?.success) {
      throw new Error(data?.message || "Failed to update order status.");
    }

    return data.order;
  },

  subscribeToOrders(onChange) {
    if (!isSupabaseConfigured) return null;

    return supabase
      .channel("public:orders")
      .on("postgres_changes", { event: "*", schema: "public", table: "orders" }, onChange)
      .subscribe();
  },
};
